import { CandleData } from 'client/voladeum/candles/types';
import { PARAMETER } from 'enums';

import { EMPTY_OBJECT, PARAMETER_NAME } from '../constants';

export const getParametersLabel = (parameters: Record<string, unknown> = EMPTY_OBJECT): string => {
  if (!parameters || typeof parameters !== 'object') {
    return '';
  }

  try {
    return Object.entries(parameters)
      .map(([key, value]) => `(${PARAMETER_NAME[key as PARAMETER]} ${value})`)
      .join(', ');
  } catch (error) {
    console.error('error generating parameters label:', error);
    return '';
  }
};

export const retrieveCandle = (
  candles: CandleData[],
  index: number
): { current: CandleData; previous: CandleData } => {
  const current = candles[index];
  const previous = candles[index - 1];
  return { current: populateCandle(current), previous: populateCandle(previous) };
};

export const populateCandle = (c?: CandleData): CandleData => {
  return c ? c : { x: 0, o: 0, h: 0, l: 0, c: 0, v: 0 };
};
